import { apiConsultationSlice } from "@/redux/app/api/apiSlice";

export const consultationApiSlice = apiConsultationSlice.injectEndpoints({
  endpoints: (builder) => ({
    createFreeConsultation: builder.mutation({
      query: (body) => ({
        url: `/api/consultation/free`,
        method: "POST",
        body: body,
      }),
      // providesTags: ["Profile"],
      invalidatesTags: ["Consultation"],
    }),
    createOtherConsultation: builder.mutation({
      query: (body) => ({
        url: `/api/consultation/other`,
        method: "POST",
        body: body,
      }),
      // providesTags: ["Profile"],
      invalidatesTags: ["Consultation"],
    }),
    createPaidConsultation: builder.mutation({
      query: (body) => ({
        url: `/api/consultation/paid`,
        method: "POST",
        body: body,
      }),
      // providesTags: ["Profile"],
      invalidatesTags: ["Consultation"],
    }),
    getServces: builder.query({
      query: () => ({
        url: `/api/consultation/services`,
        method: "GET",
      }),
      // providesTags: ["Profile"],
    }),
    getPaidConsultationSetting: builder.query({
      query: () => ({
        url: `/api/home/consultation/setting`,
        method: "GET",
      }),
      // providesTags: ["Profile"],
    }),
    getTimes: builder.query({
      query: () => ({
        url: `/api/home/consultation/time`,
        method: "GET",
      }),
      // providesTags: ["Profile"],
    }),
    getPaidConsultation: builder.query({
      query: (params) => ({
        url: `/api/dashboard/consultation/paid`,
        method: "GET",
        params: { ...params },
      }),
      providesTags: ["Consultation"],
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          JSON.stringify(currentArg?.params?.page) !==
            JSON.stringify(previousArg?.params?.page) ||
          JSON.stringify(currentArg?.params?.limit) !==
            JSON.stringify(previousArg?.params?.limit)
        );
      },
    }),
    getfreeConsultation: builder.query({
      query: (params) => ({
        url: `/api/dashboard/consultation/free`,
        method: "GET",
        params: { ...params },
      }),
      providesTags: ["Consultation"],
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          JSON.stringify(currentArg?.params?.page) !==
            JSON.stringify(previousArg?.params?.page) ||
          JSON.stringify(currentArg?.params?.limit) !==
            JSON.stringify(previousArg?.params?.limit)
        );
      },
    }),

    getOtherConsultation: builder.query({
      query: ({ params, lang }) => ({
        url: `/api/dashboard/consultation/other`,
        params: { ...params },
        headers: {
          "Accept-Language": lang,
        },
      }),
      providesTags: ["Consultation"],
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          JSON.stringify(currentArg?.params?.page) !==
            JSON.stringify(previousArg?.params?.page) ||
          JSON.stringify(currentArg?.params?.limit) !==
            JSON.stringify(previousArg?.params?.limit)
        );
      },
    }),
    readConsultation: builder.mutation({
      query: (id) => ({
        url: `/api/dashboard/consultation/answered/${id}`,
        method: "POST",
        body: id,
      }),
      invalidatesTags: ["Consultation"],
    }),
  }),
});

export const {
  useCreateFreeConsultationMutation,
  useCreateOtherConsultationMutation,
  useCreatePaidConsultationMutation,
  useGetServcesQuery,
  useGetTimesQuery,
  useGetPaidConsultationQuery,
  useGetfreeConsultationQuery,
  useGetOtherConsultationQuery,
  useReadConsultationMutation,
  useGetPaidConsultationSettingQuery,
} = consultationApiSlice;
